import React, { useState, useEffect } from 'react';
import Icon from '../../components/Icon';

function StatBox({ label, value }) {
  return (
    <div className="lor-legacy-stat">
      <div className="lor-legacy-stat-val">{value ?? '—'}</div>
      <div className="lor-legacy-stat-label">{label}</div>
    </div>
  );
}

function MilestoneItem({ milestone }) {
  const { year, description, icon } = milestone;
  return (
    <div className="lor-legacy-milestone">
      <div className="lor-legacy-milestone-year">{year}</div>
      {icon && <span className="lor-legacy-milestone-icon">{icon}</span>}
      <div className="lor-legacy-milestone-desc">{description}</div>
    </div>
  );
}

export default function LORCommissionerLegacy({ api }) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    fetch(`${api}/api/lor/lore/commissioner-legacy`)
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(d => { setData(d); setLoading(false); })
      .catch(() => { setError('Commissioner Legacy unavailable.'); setLoading(false); });
  }, [api]);

  if (loading) return <div className="lor-loading">Loading Commissioner Legacy…</div>;
  if (error)   return <div className="lor-empty">{error}</div>;

  const d = data || {};
  const milestones     = d.milestones || [];
  const stats          = d.stats || {};
  const builderCard    = d.leagueintel_card || {};
  const narrative      = d.narrative;

  return (
    <div className="lor-legacy-page">
      <div className="lor-page-header">
        <h2 className="lor-page-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}><Icon emoji="👑" size={18} /> Commissioner Legacy</h2>
        <div className="lor-page-meta">League of Record · Est. 2012</div>
      </div>

      {/* Hero */}
      <div className="lor-legacy-hero lor-card">
        <div className="lor-legacy-hero-icon"><Icon emoji="👑" size={28} /></div>
        <div className="lor-legacy-hero-info">
          <div className="lor-legacy-hero-name">
            {d.commissioner_name || 'PhillyxCommish'}
          </div>
          <div className="lor-legacy-hero-sub">
            {d.commissioner_subtitle || '13 of 14 Seasons · 2012–Present'}
          </div>
          <div className="lor-legacy-badge"><Icon emoji="👑" size={13} style={{ verticalAlign: 'middle', marginRight: 3 }} /> Commissioner Legend</div>
        </div>
      </div>

      {/* Stats row */}
      <div className="lor-legacy-stats lor-card">
        <StatBox label="Seasons as Commissioner" value={stats.seasons_as_commissioner ?? d.seasons_as_commissioner} />
        <StatBox label="Seasons in League"        value={stats.seasons_in_league ?? d.seasons_in_league} />
        <StatBox label="Championships Won"        value={stats.championships ?? d.championships} />
        <StatBox label="League Founded"           value={stats.league_founded ?? d.league_founded ?? '2012'} />
      </div>

      {/* Narrative */}
      {narrative && (
        <div className="lor-legacy-narrative lor-card">
          <p>{narrative}</p>
        </div>
      )}

      {/* Milestones */}
      {milestones.length > 0 && (
        <div className="lor-legacy-milestones lor-card">
          <div className="lor-legacy-section-title">The Milestones</div>
          <div className="lor-legacy-milestones-list">
            {milestones.map((m, i) => (
              <MilestoneItem key={i} milestone={m} />
            ))}
          </div>
        </div>
      )}

      {/* LeagueIntel builder card */}
      {(builderCard.title || d.leagueintel_narrative) && (
        <div className="lor-legacy-builder-card lor-card">
          <div className="lor-legacy-builder-badge"><Icon emoji="💡" size={13} style={{ verticalAlign: 'middle', marginRight: 3 }} /> Platform Architect</div>
          <div className="lor-legacy-builder-title">
            {builderCard.title || 'LeagueIntel'}
          </div>
          <p className="lor-legacy-builder-body">
            {builderCard.narrative || d.leagueintel_narrative}
          </p>
        </div>
      )}
    </div>
  );
}
